import { ICatalogueThemesResponse, IClusterSearchResponse } from './../../../core/models/thematic.model';
import { Injectable } from '@angular/core';
import { ITrendsResponse } from '../../../core/models/thematic.model';
import { HttpClient, HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ThematicService {

  constructor(private http: HttpClient) { }

  searchClusters(searchTerm: string) {
    return this.http.post<IClusterSearchResponse>(
      '/backend/thematicView/search/clusters',
      { search_term: searchTerm },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('current_user_token')
        },
        responseType: 'json'
      }
    );
  }


  generateAITheme(user_message:string){
  return this.http.post<any>(
      '/backend/themeAssistant/theme/define',
      { user_message: user_message },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('current_user_token')
        },
        responseType: 'json'
      }
    );  }

  generateThemeName(query: string){
  return this.http.post<any>(
      '/backend/themeAssistant/theme/name',
      { query: query },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('current_user_token')
        },
        responseType: 'json'
      }
    );  }

}
